import classNames from 'classnames'
import { ReactElement, useState } from 'react'
import { useField } from 'remix-validated-form'
import FormHiddenInput from './FormHiddenInput'
import FormInputWrapper, { FormInputWrapperProps } from './FormInputWrapper'

export type FormColorSelectorProps = {
  presetColors: string[]
  defaultColor: string
  colorClassName?: string
  labelClassName?: string
} & FormInputWrapperProps<HTMLInputElement>

export function FormColorSelector({
  name,
  presetColors,
  defaultColor,
  label,
  type = `color`,
  placeholder,
  disabled,
  cols,
  className,
  wrapperClassName,
  colorClassName,
  labelClassName,
  errorClassName,
  showErrorIcon,
  newLineError,
  error,
  onChange,
  ...props
}: FormColorSelectorProps): ReactElement {
  const { error: err, defaultValue } = useField(name)
  const [selectedColor, setSelectedColor] = useState<string>(defaultValue || defaultColor)
  return (
    <FormInputWrapper
      {...{
        name,
        label,
        error: err ?? error,
        showErrorIcon,
        newLineError,
        cols,
        wrapperClassName,
        className: labelClassName ?? `text-ui-sm`,
        errorClassName,
        defaultValue: props.defaultValue,
      }}
    >
      <div className={colorClassName ?? `grid grid-cols-7 gap-1.5`}>
        {presetColors?.map((color) => {
          return (
            <div
              key={color}
              className={classNames(
                `col-span-1 h-7.5 aspect-square cursor-pointer rounded-lg border border-transparent hover:ring-2 hover:ring-strong hover:ring-offset-1`,
                `bg-${color}`,
                {
                  'ring-2 ring-strong ring-offset-1': color === selectedColor,
                },
              )}
              onClick={() => setSelectedColor(color)}
            ></div>
          )
        })}
      </div>
      <FormHiddenInput name={name} value={selectedColor} />
    </FormInputWrapper>
  )
}
